export const setDisplayType = data => ({
    type: 'SET_DISPLAY_VALUE',
    data
});